import { useAtomValue } from 'jotai'
import { FC } from 'react'
import { PropertyRecordsDetailsOwners } from 'src/components/insights/property-records/details/owners'
import { UnavailableCardContent } from 'src/components/insights/unavailable-card-content'
import { parcelPropertyRecords } from 'src/v2/state/owner-reveal/parcel-property-records'

export const ParcelPropertyOwnersContent: FC = () => {
  const data = useAtomValue(parcelPropertyRecords)

  if (!data?.owners) {
    return <UnavailableCardContent message="Sorry, but we couldn't find the information requested for this parcel." />
  }

  return <PropertyRecordsDetailsOwners owners={data.owners} />
}
